"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/prop-types */
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var resolveBasename_1 = __importDefault(require("./resolveBasename"));
var IpfsRouter = function (props) {
    var _a, _b, _c;
    var path = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname, (_c !== null && _c !== void 0 ? _c : '/'));
    var basename = resolveBasename_1.default(path);
    return react_1.default.createElement(react_router_dom_1.BrowserRouter, __assign({}, props, { basename: basename }));
};
exports.default = IpfsRouter;
//# sourceMappingURL=IpfsRouter.js.map